// extracted by mini-css-extract-plugin
export default {"info":"Footer_info__TmKKt","social_media_icons":"Footer_social_media_icons__JcqGk","links":"Footer_links__vUbnJ"};